// eslint-disable-next-line import/prefer-default-export -- aggregate modules don't export default value
export const DELAY_TIMEOUT = 500;
